
import { FC, useContext, useState } from "react";
import { SidebarContext } from "../../../../../contexts/SidebarContext";
import { Contacts } from "../../../../../shared/interfaces/contacts";
import SearchBox from "../../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../../shared/components/tableViewContainer";
import Loader from "../../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../../shared/components/noPermissionBanner";
import DataTable from "../../../../../shared/components/dataTable";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import ContactView from "./contactView";


interface ContactListProps {
  organizationId: string;
  entityPermissions: string[];
}

const ContactList: FC<ContactListProps> = ({ organizationId, entityPermissions }) => {

  const { payload, setPayload } = useContext(SidebarContext);
  const [selectedContactId, setSelectedContactId] = useState<string | null>(
    null
  );

  const { loading: contactLoading, data: contactsData, error } = useQuery(
    "/admin/organization-contacts",
    {
      params: {
        ...payload,
        entityId: organizationId,
        entityType: "Organization"
      },
    }
  );

  let contactsList: Contacts[] = [];

  if (contactsData && (contactsData as any)?.items) {
    contactsList = (contactsData as any)?.items.map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        phone: item.phone,
        designation: item.designation,
        default: item.defaultContact === true ? 'Yes' : 'No'
      }
    });
  }

  const adminDisplayColumns = ["name", "phone", "designation", "default"];


  const handleRowClick = (rowData: Contacts) => {
    setSelectedContactId(rowData.id);
  };

  const titleBar = {
    title: "",
    headerTitle: "",
    filter: false,
    disabled:  entityPermissions
    ? !entityPermissions?.includes("Reseller-Read")
    : false,
    titleBarNodes: (
      <SearchBox />
    ),
  };

  return (
    <>
      {selectedContactId ? (
        <ContactView
          id={selectedContactId}
          onClose={() => setSelectedContactId(null)}
        />
      ) : (
        <TableViewContainer titleBar={titleBar}>
          {contactLoading && <Loader />}
          {(error as any)?.statusCode === 403 && <NoPermissionContent />}
          {!contactLoading && !error && (

            <DataTable
              entityName="Contact"
              data={contactsList}
              displayColumns={adminDisplayColumns}
              linkColumn="name"
              linkUrl="/resellers/contact"
              pagination={{ take: payload.take, skip: payload.skip }}
              setPagination={setPayload}
              totalItems={(contactsData as any)?.totalItems}
              renderCell={(row, column) => (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRowClick(row);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {row[column]}
                </div>
              )}
            />
          )}
        </TableViewContainer>)}
    </>
  );
};

export default ContactList;


